import * as Sentry from '@sentry/vue';
import { useImmersveAuthStore } from '@/stores/auth.store';
import { wellKnownRoutes } from '@/routes/wellknown';
import type { RouteLocationNormalized } from 'vue-router';

export function beforeEachGuard(to: RouteLocationNormalized) {
  const sessionId = to.params.sessionid as string;

  if (!sessionId && (to?.meta?.requiresAuth || to?.meta?.requiresKycStatus)) {
    Sentry.captureMessage('Invalid session id');
    return {
      name: wellKnownRoutes.Timeout,
      replace: true,
    };
  }

  const authStore = useImmersveAuthStore();
  authStore.initialiseSession(sessionId);

  if (
    to?.meta?.requiresAuth &&
    authStore.hasInvalidAccessToken() &&
    authStore.hasInvalidRefreshToken()
  ) {
    return {
      name: wellKnownRoutes.Timeout,
      replace: true,
      query: {
        correlationId: sessionId,
      },
    };
  }
}
